import { signal, Service } from '@angular/core';

import { type Profile } from '@entities/profile';

import { type AuthStatus } from './models/auth-status';

@Service()
export class AuthStore {
  private readonly authUser = signal<Profile | null>(null);
  private readonly authStatus = signal<AuthStatus>('guest');

  readonly user = this.authUser.asReadonly();
  readonly status = this.authStatus.asReadonly();

  constructor() {
    const user = localStorage.getItem('rainbowSurrogacyUserEmail');
    if (user) {
      this.setUserData(JSON.parse(user));
    }
  }

  setStatusGuest(): void {
    this.authUser.set(null);
    this.authStatus.set('guest');
  }

  setStatusAuthed(): void {
    this.authStatus.set('authed');
  }

  setUserData(user: Profile): void {
    this.authUser.set(user);
    localStorage.setItem('rainbowSurrogacyUserEmail', JSON.stringify(user));
  }
}
